// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"648c155e","426":"231b21be","447":"c50a676e","459":"0174f7f9","560":"dd570a39","569":"b9badf6f","774":"44b82253","937":"03850bc3","962":"42f59fca","998":"b3d416a5"}[chunkId] + ".chunk.js";
};